import ServiceBuilder from "@/_services/api.service";
import axios from "@/lib/axios";
import store from "@/store";

const Demande = ServiceBuilder(axios, 'demandes')
Demande.setOptions({ sortBy: "numero", sortDesc: true })

Demande.updateStatus = async function (numero_demande, idStatut) {
    return this.axios.put(`api/demandes/${numero_demande}/statut`, { idStatut })
}

// addDocument details to demande (by id) 
Demande.addDocument = async function (type, body) {
    console.log({ DOCUMENT_TYPE: type })
    const { files, ...rest } = body
    try {
        const newDocument = await this.axios.post(`api/${type}`, rest)
        if (newDocument.status >= 300) {
            throw new Error("erreur lors de l'enregistrement des informations du document " + type)
        } else {
            // REGISTER FILES 
            const { main, additional = [] } = files;
            try {
                const filesToUpload = !additional ? main : [...main, ...additional]
                const recordDocumentPromises = filesToUpload.reduce((files, currentFile) => {
                    if (currentFile) {
                        const body = {
                            type: store.getters['Classeur/iriFromLabel'](type),
                            file: currentFile,
                            demande: rest.demande,
                            fileName: currentFile.name
                        }
                        const fileUpload = store.dispatch("Classeur/saveDocument", body);
                        return [...files, fileUpload]
                    } else {
                        return files
                    }
                }, [])

                const resp = await Promise.allSettled(recordDocumentPromises)
                const areAllPromisesFullfilled = resp.every(result => result.status === 'fulfilled')
                if (!areAllPromisesFullfilled) {
                    throw new Error('Au moins un des fichiers  n\'à pas été enregistré correctement')
                } else {
                    return {
                        result: resp,
                        error: false
                    }
                }
            } catch (error) {
                console.log(error);
                throw error
                // throw new Error("Un problème est survenu lors du dépôt de document.");
            }
        }
    } catch (error) {
        return { error: true, message: error.message }
    }
}


export default Demande;